import React, { useState } from "react";
import { createCohort, getCohortbyCohortID } from "../../services/cohort";
import Button from "../../components/inputs/button";
import ModalSurface from "./ModalSurface";
import PropTypes from "prop-types";
import "./index.scss";
import x from "../../assets/svgs/x-green.svg";
import BasicInput from "../../components/inputs/basic";

function CopyCohort({ cohort, onUpdate, getCohorts, selectedRows }) {
	const cohortData = cohort;
	const [message, setMessage] = useState(null);
	const [showCopySuccess, setShowCopySuccess] = useState(false);
	const [showCopyError, setShowCopyError] = useState(false);
	const [tagId, setTagId] = useState(localStorage.getItem("activeSilo"));
	const [loading, setLoading] = useState(false);

	const [newName, setNewName] = useState("");

	const handleCopy = async () => {
		setLoading(true);
		try {
			const data = await getCohortbyCohortID(cohortData[0].value, tagId);
			const dataObj = data.data;
			dataObj.name = newName;
			dataObj.cid = null;
			dataObj.unique_id = null;
			// A new audience starts its own versions (ASB-4801).
			delete dataObj.version;
			if (dataObj.auto_generated) {
				dataObj.auto_generated = false;
				dataObj.tagId = parseInt(tagId);
			}
			// ASB-3712: the API no longer accepts new schema_version 1.0 composite audiences. The fetched
			// object always carries composite_conditions_v2 (derived server-side for 1.0 sources), so copy
			// as 2.0 and drop the legacy composite_conditions. Modeled audiences keep their payload.
			if (dataObj.cohort_type === "composite") {
				dataObj.schema_version = "2.0";
				delete dataObj.composite_conditions;
			}
			const payload = { data: [dataObj] };
			createCohort(payload)
				.then((r) => {
					r.json().then((responseData) => {
						setMessage(responseData.message || "Audience copied successfully");
						setShowCopySuccess(true);
						setLoading(false);
						setTimeout(() => {
							setShowCopySuccess(false);
							getCohorts(tagId);
							onUpdate();
							selectedRows("");
						}, 3000);
					});
				})
				.catch((error) => {
					const errorMessage = error.data?.message || error.message || "Failed to copy audience";
					setMessage(errorMessage);
					setShowCopyError(true);
					setLoading(false);
				});
		} catch (error) {
			const errorMessage = error.message || "Failed to fetch audience data";
			setMessage(errorMessage);
			setShowCopyError(true);
			setLoading(false);
		}
	};

	if (showCopySuccess || showCopyError) {
		const status = showCopySuccess ? "Success" : "Error";
		const dotClass = showCopySuccess ? "dot--Success" : "dot--Error";
		return (
			<div id="archive-box">
				<div className="toastContainer">
					<div className="toast--inner">
						<div className="toast--inner--head">
							<div>
								<span className={dotClass}> </span> {status}
							</div>
							<img
								src={x}
								className="close"
								alt="close"
								role={"button"}
								onClick={() => onUpdate()}
							/>
						</div>
						<div className="toast--inner--body">
							<p className="p3 no-margin">{message}</p>
						</div>
					</div>
				</div>
			</div>
		);
	}

	const footer = (
		<>
			<button
				type="button"
				className="cancel-link"
				onClick={() => onUpdate()}
				disabled={loading}
			>
				Cancel
			</button>
			<Button
				loaded={loading}
				onClick={() => handleCopy()}
				text="Confirm"
				style="dark"
				type="button"
				disabled={loading || !newName}
			/>
		</>
	);

	return (
		<ModalSurface title="Copy Audience" onClose={onUpdate} footer={footer} closeDisabled={loading}>
			<p className="p3">You are copying &apos;{cohortData[0].label}&apos;. Please enter a new name:</p>
			<div className="modal-field">
				<BasicInput
					className="input-field"
					name="newAudienceName"
					placeholder="New Audience Name"
					required={true}
					onInput={(e) => setNewName(e.target.value)}
				/>
			</div>
		</ModalSurface>
	);
}

CopyCohort.propTypes = {
	cohort: PropTypes.any,
	onUpdate: PropTypes.func,
	getCohorts: PropTypes.func,
	selectedRows: PropTypes.func,
};

export default CopyCohort;
